import styled from '@emotion/styled';

const GnbMenuItem = styled('li')`
  display: flex;
  align-items: center;
  height: 48px;
`;

export default GnbMenuItem;
